import { render, staticRenderFns } from "./LastMasterclass.vue?vue&type=template&id=46b2e373&scoped=true&"
import script from "./LastMasterclass.vue?vue&type=script&lang=js&"
export * from "./LastMasterclass.vue?vue&type=script&lang=js&"
import style0 from "./LastMasterclass.vue?vue&type=style&index=0&id=46b2e373&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b2e373",
  null
  
)

export default component.exports